/**
 * sidebarRoutes — regra pura de auto-colapso da Sidebar por rota.
 *
 * Certas telas são densas (canvas de construção, tela cheia de device,
 * detalhe de execução ao vivo, Live Preview) e se beneficiam de mais
 * espaço horizontal. Nessas rotas a Sidebar colapsa automaticamente ao
 * entrar; o usuário ainda pode expandir manualmente (mini-botão) ou passar
 * o mouse para revelar (hover-expand).
 *
 * Rotas de auto-colapso:
 *   • /preview                          — Live Preview
 *   • /devices                          — grade de devices
 *   • /executions/{id}                  — detalhe de execução (NÃO a lista)
 *   • /test-cases/new | /test-cases/{id}   — canvas do editor (NÃO lista/versions)
 *   • /test-suites/new | /test-suites/{id} — canvas do editor (NÃO lista/versions)
 *
 * A função é pura (só depende do pathname) para ser testável e reutilizável.
 */

/** Padrões de rota que disparam auto-colapso da Sidebar. */
const AUTO_COLLAPSE_PATTERNS: readonly RegExp[] = [
  /^\/preview\/?$/,
  /^\/devices\/?$/,
  // Detalhe de execução, mas não a lista (`/executions`).
  /^\/executions\/[^/]+\/?$/,
  // Canvas do editor de test case: /new ou /{id}, excluindo /{id}/versions.
  /^\/test-cases\/(new|[^/]+)\/?$/,
  // Canvas do editor de test suite: idem.
  /^\/test-suites\/(new|[^/]+)\/?$/,
]

/**
 * `true` se a rota informada deve colapsar a Sidebar automaticamente.
 *
 * Normaliza query string / hash antes de casar os padrões.
 */
export function isAutoCollapseRoute(pathname: string): boolean {
  if (!pathname) return false
  // Remove query e hash — só o path importa.
  const path = pathname.split('?')[0]!.split('#')[0]!
  return AUTO_COLLAPSE_PATTERNS.some((re) => re.test(path))
}
